export default "__VITE_ASSET__CVn6jD7M__"